// extracted by mini-css-extract-plugin
module.exports = {"container":"FlowFooter-module__container--CQVJM","inner":"FlowFooter-module__inner--37bMh","innerRight":"FlowFooter-module__innerRight--2qyQf"};